import React, { useState, useEffect } from "react";

const Features = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const features = [
    {
      icon: "/market.svg",
      title: "P2P Marketplace",
      features: [
        "Zero-fee trading",
        "Multiple payment methods",
        "Verified merchants",
        "Escrow-powered secure trades"
      ]
    },
    {
      icon: "/trading.svg",
      title: "Spot Trading",
      features: [
        "Deep liquidity",
        "Low fees",
        "Advanced charting with TradingView",
        "200+ trading pairs"
      ]
    },
    {
      icon: "/fiaton.svg",
      title: "Fiat On/Off Ramp",
      features: [
        "Deposit & withdraw PKR, AED, SAR",
        "Bank transfer + wallets",
        "Compliance-ready KYC",
        "No hidden charges"
      ]
    }
  ];

  return (
    <section
      className="relative py-12 sm:py-16 md:py-20 bg-black overflow-hidden"
      style={{
        background:
          "radial-gradient(51.47% 93.67% at 92.92% 27.08%, #384991 0%, #161837 72.6%)",
      }}
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div
          className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
            Key Feature <span className="text-white">Highlights</span>
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`transition-all duration-700 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-20"
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="bg-[#35375E] border border-[#2A356D] rounded-xl p-6 sm:p-8 h-full flex flex-col">
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 border-[#2A356D] bg-[#1a1b3a] flex items-center justify-center">
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                    />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl sm:text-2xl font-bold text-white text-center mb-6">
                  {feature.title}
                </h3>

                {/* Features List */}
                <ul className="space-y-3 sm:space-y-4 flex-1">
                  {feature.features.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-[#0E1696] rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-white text-sm sm:text-base">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
